/**
 * Given an element, this function traverses the DOM upwards until it finds the overflowSet item container element
 *
 * @param element The base control element
 * @returns The sought parent element if found
 */
export function findParentItemByClass(element, classname) {
    var _a;
    if (!element) {
        return null;
    }
    if ((_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(classname)) {
        return element;
    }
    return findParentItemByClass(element.parentElement, classname);
}
//# sourceMappingURL=findParentElementByClass.js.map